/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} CloseInputs */

const en_close = /** @type {(inputs: CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close`)
};

const fr_close = /** @type {(inputs: CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fermer`)
};

const de_close = /** @type {(inputs: CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schließen`)
};

const it_close = /** @type {(inputs: CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vicino`)
};

const ru_close = /** @type {(inputs: CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Закрывать`)
};

const es_close = /** @type {(inputs: CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerca`)
};

const zh_cn2_close = /** @type {(inputs: CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关闭`)
};

const ja_close = /** @type {(inputs: CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`近い`)
};

const hi_close = /** @type {(inputs: CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बंद करना`)
};

const pt_pt2_close = /** @type {(inputs: CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fechar`)
};

/**
* | output |
* | --- |
* | "Close" |
*
* @param {CloseInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const close = /** @type {((inputs?: CloseInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<CloseInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_close(inputs)
	if (locale === "de") return de_close(inputs)
	if (locale === "it") return it_close(inputs)
	if (locale === "ru") return ru_close(inputs)
	if (locale === "es") return es_close(inputs)
	if (locale === "zh-CN") return zh_cn2_close(inputs)
	if (locale === "ja") return ja_close(inputs)
	if (locale === "hi") return hi_close(inputs)
	if (locale === "pt-PT") return pt_pt2_close(inputs)
	return en_close(inputs)
});